import type { PropsWithChildren } from 'react'
import { clsx } from 'clsx/lite'
import { forwardRef } from 'react'
import { CloseButton } from './CloseButton'

type Props = PropsWithChildren<{
  className?: string
  onClickClose?: () => void
}>

export const PageContainer = forwardRef<HTMLDivElement, Props>(({ children, className, onClickClose }, ref) => {
  return (
    <div
      className={clsx('coorum-research h-full overflow-y-auto', className)}
      ref={ref}
    >
      <div className="sticky top-0 flex h-[40px] items-center justify-end px-2">
        <CloseButton onClick={onClickClose} />
      </div>
      <div className="relative h-[calc(100%-40px)]">
        {children}
      </div>
    </div>
  )
})
